__turbopack_context__.v({
  "tabLinkList": "tabLinkList-module-scss-module__fPQb4q__tabLinkList",
});
